'use client'

import { useSetAtom } from 'jotai'
import { useCallback } from 'react'

import type { HubEntryId } from '@/features/tutorial/lib/tutorial-progress'
import { tutorialHubFocusAtom, tutorialHubOpenAtom } from '@/state/tutorial'

/** Opens the tutorials hub, on `focus` when given (else on the first thing left to do). */
export function useOpenTutorialHub() {
  const setOpen = useSetAtom(tutorialHubOpenAtom)
  const setFocus = useSetAtom(tutorialHubFocusAtom)
  return useCallback(
    (focus?: HubEntryId) => {
      setFocus(focus ?? null)
      setOpen(true)
    },
    [setOpen, setFocus]
  )
}
